import { EditorV3Content, IEditorV3 } from "../classes";

/**
 * Searches EditorV3 content for a text phrase and counts the number of matching lines.
 * Performs case-insensitive search across all lines in the content.
 *
 * @param searchText - The search term to find in EditorV3 content
 * @param editorV3Content - The EditorV3 content to search within
 * @returns The number of lines containing the search text
 */
export const searchEditorV3Content = (
  searchText: string,
  editorV3Content: IEditorV3 | undefined,
): number => {
  if (!editorV3Content || !editorV3Content.lines) {
    return 0;
  }
  const content = new EditorV3Content(editorV3Content);
  // Extracted function to count line matches
  return content.lines
    .map((l) => (l.lineText.toLowerCase().includes(searchText.toLowerCase()) ? 1 : 0))
    .reduce((a: number, b: number) => a + b, 0);
};
